<template>
	<div class="map-part">
		<title1 title="安全指标" subTitle="Security Index" />
		<div class="contion">
			<div class="item">
				<dv-water-level-pond class="margin-top20" :config="config" style="width:170px;height:170px" />
				<span>电池健康度</span>
			</div>
			<div class="box1">
				<divBox title="平均变化速度">
					<myEchart v-if="showcdata1" :id="'averageSpeed'" :options="cdata1" />
				</divBox>
			</div>
			<div class="box1">
				<divBox title="SOC仿真平均变化里程">
					<myEchart v-if="showcdata2" :id="'socAverageSpeed'" :options="cdata2" />
				</divBox>
			</div>
			<div class="box1">
				<divBox title="SOC仿真平均变化时长">
					<myEchart v-if="showcdata3" :id="'socAverageChangeTime'" :options="cdata3" />
				</divBox>
			</div>
		</div>
	</div>
</template>

<script>
import infoList from "../infoList";
import divBox from "./divbox2";
import bigTitle from "./bigTitle";
import myEchart from "../charts/echarts";
import { dataInterface } from "@/api/dataInterfaceApi";
import title1 from '@/views/exposition/components/title1'
import * as echarts from "echarts5";

export default {
	components: {
		myEchart,
		bigTitle,
		divBox,
		infoList,
		title1
	},
	data() {
		return {
			bigtitle: {
				CHN: "安全指标",
				ENG: "Traffic indicators",
			},
			config: {
				data: [66],
				shape: 'round',
				colors: ['#91D5FF', '#1890FF']
			},
			// 平均变化速度
			showcdata1: false,
			cdata1: {
				backgroundColor: 'rgba(0, 0, 0, 0.1)',
				tooltip: {
					trigger: 'axis',
					formatter: function(params) {
						return (
							'SOC：' + params[0].axisValue + '<br>' +
							'平均变化速度（km/min）：' + params[0].data
						)
					},
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					splitLine: false
				},
				legendData: [{
					name: "新增数",
					icon: 'roundRect',
				}, {
					name: "活跃数",
					icon: 'roundRect',
				}],
				series: [{
					type: 'line',
					areaStyle: {},
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: 'rgba(25, 104, 255,0.42)' // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: 'rgba(61, 230, 255,0)' // 100% 处的颜色
									}
								],
								globalCoord: false // 缺省为 false
							}
						}
					},
					itemStyle: {
						normal: {
							color: '#3649F4', //改变折线点的颜色
							lineStyle: {
								color: '#3649F4' //改变折线颜色
							}
						}
					}
				}]
			},
			showcdata2: false,
			// title:"车辆新增及活跃趋势",
			cdata2: {
				title: {
					text: "km",
				},
				backgroundColor: 'rgba(0, 0, 0, 0.1)',
				tooltip: {
					trigger: 'axis',
					formatter: function(params) {
						return (
							'SOC：' + params[0].axisValue + '<br>' +
							'平均变化里程（km）：' + params[0].data
						)
					},
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value',
					splitLine: false
				},
				legendData: [{
					// name:"新增数",
					icon: 'roundRect',
				}, {
					// name:"活跃数",
					icon: 'roundRect',
				}],
				series: [{
					data: [820, 932, 901, 934, 1290, 1330, 1320],
					type: 'line',
					areaStyle: {},
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: '#EDC96E' // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: '#181308' // 100% 处的颜色
									}
								],
								globalCoord: false // 缺省为 false
							}
						}
					},
					itemStyle: {
						normal: {
							color: '#EDC96E', //改变折线点的颜色
							lineStyle: {
								color: '#EDC96E' //改变折线颜色
							}
						}
					}
				}]
			},
			showcdata3: false,
			// title:"SOC仿真平均变化时长",
			cdata3: {
				title: {
					text: "km",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				tooltip: {
					trigger: 'axis',
					formatter: function(params) {
						return (
							'SOC：' + params[0].axisValue + '<br>' +
							'平均变化时长（km/min）：' + params[0].data
						)
					},
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value',
					splitLine: false
				},
				legendData: [{
					// name:"新增数",
					icon: 'roundRect',
				}, {
					// name:"活跃数",
					icon: 'roundRect',
				}],
				series: [{
					type: 'line',
					areaStyle: {},
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: '#73F0F3' // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: '#193C3D' // 100% 处的颜色
									}
								],
								globalCoord: false // 缺省为 false
							}
						}
					},
					itemStyle: {
						normal: {
							color: '#6CE3E6', //改变折线点的颜色
							lineStyle: {
								color: '#397A7B' //改变折线颜色
							}
						}
					}
				}]
			}
		};
	},
	props: {
		// cdata: {
		//   type: Object,
		//   default: () => ({}),
		// },
	},
	watch: {},
	mounted() {
		//获取电池健康度
		this.getBatteryHealthy()
		// SOC仿真平均能耗
		this.getBattery1()
		//SOC仿真平均变化里程
		this.getBattery2()
		//SOC仿真平均变化时长
		this.getBattery3()
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log("sf123123123123123123123", data);
		},
		//获取电池健康度
		getBatteryHealthy() {
			let params = {
				"enCode": "per_vehicle-电池健康度",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") :
					'LDP31B967MG929008'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (res) {
					let arr = []
					this.config.data = [res[0].soh * 1]
					this.config = {
						...this.config
					}
				}

			}).catch((err) => {
				console.log(err);
			});
		},
		// SOC仿真平均能耗
		getBattery1() {
			let params = {
				"enCode": "per_vehicle-平均变化速度",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (res) {
					let data = []
					let xAxis = []
					res.forEach(item => {
						xAxis.push(item.soc)
						data.push(item.avg_change_speed)
					})
					this.cdata1.xAxis.data = xAxis
					this.cdata1.series[0].data = data
					this.showcdata1 = true
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		//SOC仿真平均变化里程
		getBattery2() {
			let params = {
				"enCode": "per_vehicle-soc平均变化里程",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") :
					'LDP31B967MG929008'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (res) {
					let data = []
					let xAxis = []
					res.forEach(item => {
						xAxis.push(item.soc)
						data.push(item.avg_change_mileage)
					})
					this.cdata2.xAxis.data = xAxis
					this.cdata2.series[0].data = data
					this.showcdata2 = true
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		//SOC仿真平均变化时长
		getBattery3() {
			let params = {
				"enCode": "per_vehicle-soc平均变化时长",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") :
					'LDP31B967MG929008'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (res) {
					let data = []
					let xAxis = []
					res.forEach(item => {
						xAxis.push(item.soc)
						data.push(item.avg_change_time)
					})
					this.cdata3.xAxis.data = xAxis
					this.cdata3.series[0].data = data
					this.showcdata3 = true
				}
			}).catch((err) => {
				console.log(err);
			});
		}
	},
};
</script>

<style lang="scss" scoped>
// @import './part.scss';
.contion {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-around;

	// flex-wrap: wrap;
	// align-content: stretch;
	// justify-content: space-between;
	.item {
		padding:50px 0 8px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}

.box {
	width: 100%;
	height: 355px;
}

.box1 {
	width: 430px;
	height: 340px;
	margin-top: 5px;
}
</style>
